import React from 'react';
import waiting from '../eserviceSummary/waiting-wheel-300x300.gif';

const loadingBody =
  (<div style={{ height: '100px' }}>
    <center>
      <img role="presentation" src={waiting} style={{ width: '150px', height: '150px' }} />
    </center>
    <center>
      <p>
        Proszę czekać. Trwa generowanie Twojego dokumentu.
      </p>
    </center>
  </div>);

const loadingTitle = 'Generowanie dokumentu...';

const loadingData = { loadingBody, loadingTitle };
export default loadingData;



// WEBPACK FOOTER //
// src/routes/eservices/loading.js